import {Component, OnInit} from '@angular/core';

@Component({
	selector: 'k-table-container',
	templateUrl: './table-container.component.html',
	styleUrls: ['./table-container.component.scss']
})
export class TableContainerComponent implements OnInit {

	constructor() {
	}

	ngOnInit(): void {
	}

}
